// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"da5d36f2","927":"fc1912fe"}[chunkId] + ".chunk.js";
};